import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"

import Column from "../../../common/components/Column"
import DialogHeader from "./DialogHeader"
import SelectCampaignAutoComplete, {
  useSelectCampaignAutoCompleteState,
} from "./SelectCampaignAutoComplete"
import UpdateCreateEmailCampaignDialog, {
  useUpdateCreateEmailCampaignDialogState,
} from "./UpdateCreateEmailCampaignDialog"

export default function BulkSendEmailCampaignDialog({
  open,
  onClose,
  isSending,
  onSendButtonClicked,
  candidateCount,
}) {
  const {
    availableCampaigns,
    setAvailableCampaigns,
    campaignInputValue,
    setCampaignInputValue,
    selectedCampaign,
    setSelectedCampaign,
    campaignsLoaded,
    campaignsLoading,
  } = useSelectCampaignAutoCompleteState(open)
  const {
    createCampaignDialogOpen,
    setCreateCampaignDialogOpen,
    handleCreateCampaignDialogClosed,
  } = useUpdateCreateEmailCampaignDialogState()

  function handleSoftClose() {
    onClose()
  }

  function handleCreateCampaignLinkClicked() {
    setCreateCampaignDialogOpen(true)
    handleSoftClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleSoftClose}
      maxWidth="sm"
      fullWidth
      keepMounted
    >
      <DialogHeader
        title={`Send Email Template To ${candidateCount} Candidates`}
        onClose={handleSoftClose}
      />
      <DialogContent>
        <Column sx={{ gap: 2 }}>
          <SelectCampaignAutoComplete
            availableCampaigns={availableCampaigns}
            setAvailableCampaigns={setAvailableCampaigns}
            campaignInputValue={campaignInputValue}
            setCampaignInputValue={setCampaignInputValue}
            selectedCampaign={selectedCampaign}
            setSelectedCampaign={setSelectedCampaign}
            campaignsLoaded={campaignsLoaded}
            campaignsLoading={campaignsLoading}
            onCreateCampaignLinkClicked={handleCreateCampaignLinkClicked}
          />
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          disabled={!selectedCampaign || campaignsLoading}
          loading={campaignsLoading || isSending}
          onClick={() => onSendButtonClicked(selectedCampaign)}
        >
          Send
        </LoadingButton>
      </DialogActions>
      <UpdateCreateEmailCampaignDialog
        open={createCampaignDialogOpen}
        onClose={handleCreateCampaignDialogClosed(setAvailableCampaigns)}
      />
    </Dialog>
  )
}
